import { render, staticRenderFns } from "./PredefinedTrips.vue?vue&type=template&id=13fb6d63&scoped=true"
import script from "./PredefinedTrips.vue?vue&type=script&lang=js"
export * from "./PredefinedTrips.vue?vue&type=script&lang=js"
import style0 from "./PredefinedTrips.vue?vue&type=style&index=0&id=13fb6d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb6d63",
  null
  
)

export default component.exports